import ColinearInfo from './ColinearInfo';

export default ColinearInfo;